<template>
    <div class="d-flex align-items-center justify-content-center">
        <div
            v-if="!authenticated"
            class="w-100"
        >
            <h1 class="text-center mb-4">
                Register
            </h1>

            <form
                class="register-form"
                @submit.prevent="submit"
            >
                <b-row>
                    <b-col
                        cols="12"
                        lg="6"
                    >
                        <!-- First name -->
                        <div class="field-wrap">
                            <label
                                for="firstName"
                            >
                                First Name
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="firstName"
                                    v-model="firstName"
                                    v-validate="{ required: true }"
                                    :class="{ 'has-error': errors.has('firstName') }"
                                    type="text"
                                    name="firstName"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('firstName')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('firstName') }}
                                </div>
                            </div>
                        </div>
                        <!-- END First name -->
                    </b-col>
                    <b-col
                        cols="12"
                        lg="6"
                    >
                        <!-- Last name -->
                        <div class="field-wrap">
                            <label
                                for="lastName"
                            >
                                Last Name
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="lastName"
                                    v-model="lastName"
                                    v-validate="{ required: true }"
                                    :class="{ 'has-error': errors.has('lastName') }"
                                    type="text"
                                    name="lastName"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('lastName')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('lastName') }}
                                </div>
                            </div>
                        </div>
                        <!-- END Last name -->
                    </b-col>
                </b-row>

                <b-row>
                    <b-col
                        cols="12"
                    >
                        <!-- Email -->
                        <div class="field-wrap">
                            <label
                                for="email"
                            >
                                Email Address
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="email"
                                    v-model="email"
                                    v-validate="{ required: true, email: true }"
                                    :class="{ 'has-error': errors.has('email') }"
                                    type="email"
                                    name="email"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('email')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('email') }}
                                </div>
                            </div>
                        </div>
                        <!-- END Email -->
                    </b-col>
                </b-row>
                <b-row>
                    <b-col
                        cols="12"
                        lg="6"
                    >
                        <!-- Telephone -->
                        <div class="field-wrap">
                            <label
                                for="telephone"
                            >
                                Telephone
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="telephone"
                                    v-model="telephone"
                                    v-validate="{
                                        required: true,
                                        regex: /^\+?[0-9 ]+$/
                                    }"
                                    :class="{ 'has-error': errors.has('telephone') }"
                                    type="text"
                                    name="telephone"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('telephone')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('telephone') }}
                                </div>
                            </div>
                        </div>
                        <!-- END Telephone -->
                    </b-col>
                    <b-col
                        cols="12"
                        lg="6"
                    >
                        <!-- Telephone -->
                        <div class="field-wrap">
                            <label
                                for="mobile_telephone"
                            >
                                Mobile Telephone
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="mobile_telephone"
                                    v-model="mobile_telephone"
                                    v-validate="{
                                        required: true,
                                        regex: /^\+?[0-9 ]+$/
                                    }"
                                    :class="{ 'has-error': errors.has('mobile_telephone') }"
                                    type="text"
                                    name="mobile_telephone"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('mobile_telephone')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('mobile_telephone') }}
                                </div>
                            </div>
                        </div>
                        <!-- END Telephone -->
                    </b-col>
                </b-row>

                <b-row>
                    <b-col
                        cols="12"
                        lg="6"
                    >
                        <!-- Password -->
                        <div class="field-wrap">
                            <label
                                for="password"
                            >
                                Password
                            </label>
                            <div class="field-wrap__input">
                                <password
                                    id="password"
                                    ref="password"
                                    v-model="password"
                                    v-validate="{ required: true, regex: /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/ }"
                                    :class="{ 'has-error': errors.has('password') }"
                                    :toggle="false"
                                    :badge="false"
                                />
                            </div>
                            <div
                                v-if="errors.has('password')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('password') }}
                                </div>
                            </div>
                        </div>
                        <!-- END Password -->
                    </b-col>
                    <b-col
                        cols="12"
                        lg="6"
                    >
                        <!-- Confirm Password -->
                        <div class="field-wrap">
                            <label
                                for="passwordConfirmation"
                            >
                                Confirm Password
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="passwordConfirmation"
                                    v-model="passwordConfirmation"
                                    v-validate="{ required: true, confirmed: 'password' }"
                                    :class="{ 'has-error': errors.has('passwordConfirmation') }"
                                    type="password"
                                    name="passwordConfirmation"
                                >
                            </div>
                            <div
                                v-if="errors.has('passwordConfirmation')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('passwordConfirmation') }}
                                </div>
                            </div>
                        </div>
                        <!-- END Confirm Password -->
                    </b-col>
                </b-row>

                <!-- Field: Essentials -->
                <div class="field-wrap">
                    <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                        <input
                            id="field-essentials-1"
                            v-model="propertyToSell"
                            :true-value="true"
                            :false-value="false"
                            type="checkbox"
                            name="field-essentials"
                        >
                        <label for="field-essentials-1"><span class="check-element" />I have a property to sell</label>
                    </div>
                    <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                        <input
                            id="field-essentials-2"
                            v-model="hasMortgage"
                            :true-value="false"
                            :false-value="true"
                            type="checkbox"
                            name="field-essentials"
                        >
                        <label for="field-essentials-2"><span class="check-element" />I require a mortgage</label>
                    </div>
                    <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                        <input
                            id="field-essentials-3"
                            v-model="lookingToBuy"
                            :true-value="true"
                            :false-value="false"
                            type="checkbox"
                            name="field-essentials"
                        >
                        <label for="field-essentials-3"><span class="check-element" />I'm looking to buy a new house</label>
                    </div>
                </div>
                <!-- END Field: Essentials -->

                <!-- Accept privacy -->
                <b-row class="justify-content-center">
                    <b-col
                        cols="12"
                        lg="8"
                    >
                        <div class="field-wrap field-wrap--agreement">
                            <div class="field-wrap__input field-wrap__input--checkbox">
                                <input
                                    id="field-agree"
                                    v-model="agreement"
                                    v-validate="{ required: true }"
                                    :true-value="true"
                                    :false-value="false"
                                    type="checkbox"
                                    name="field-agree"
                                >
                                <label
                                    for="field-agree"
                                    class="p-sm"
                                >
                                    <span class="check-element" />
                                    <span>
                                        By submitting the following form you agree for your data to be used in accordance with the terms set out in our
                                        <router-link
                                            :to="{ name: 'privacy-policy' }"
                                            target="_blank"
                                        >
                                            Privacy Policy
                                        </router-link> and
                                        <router-link
                                            :to="{ name: 'terms-conditions' }"
                                            target="_blank"
                                        >
                                            Terms & Conditions
                                        </router-link>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- END Accept privacy -->

                <div class="d-flex justify-content-center">
                    <button
                        :class="{ disabled : !agreement }"
                        :disabled="!agreement"
                        class="btn btn--secondary"
                    >
                        Register
                    </button>
                </div>
            </form>
        </div>
        <div v-else>
            <p>You are already logged in.</p>
            <button @click="logout">
                Log Out
            </button>
            <router-link to="/">
                Dashboard
            </router-link>
        </div>
    </div>
</template>

<script>

// NOTE: New field 'telephone'

import { mapGetters, mapActions } from 'vuex';
import Password from 'vue-password-strength-meter';

export default {
    components: {
        Password
    },
    data() {
        return {
            agreement: false,
            propertyToSell: false,
            lookingToBuy: false,
            hasMortgage: true,
            telephone: '',
            mobile_telephone: '',
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordConfirmation: ''
        };
    },
    computed: {
        ...mapGetters('user', [
            'authenticated'
        ])
    },
    methods: {
        ...mapActions('user', [
            'login',
            'logout',
            'register'
        ]),
        submit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.register({
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        telephone: this.telephone,
                        mobile_telephone: this.mobile_telephone,
                        password: this.password,
                        password_confirmation: this.passwordConfirmation,
                        property_to_sell: this.propertyToSell,
                        looking_to_buy: this.lookingToBuy,
                        has_mortgage: this.hasMortgage
                    })
                        .then(() => {
                            this.$toasted.success('Registration complete! Please confirm your account by checking the email we have just sent you.');
                            this.$router.push({ name: 'login' });
                        })
                        .catch(({ response }) => {
                            this.$toasted.error(response.data.message);
                        });
                }
            });
        }
    }
};
</script>

<style lang="scss">
    .register-form {
        width: 70rem;
        max-width: 100%;
        padding: 0 3rem;
        margin: 0 auto;
    }

    .page-register {
        .content {
            max-width: 100%;
        }
    }

    .field-wrap {
        &--agreement {
            padding: 2rem;
            background: #e6e6e6;
            border-radius: global-var('rounded-corners');
        }
    }
</style>
